export const FETCH_RESERVATION_LOADING = 'FETCH_RESERVATION_LOADING';
export const FETCH_RESERVATION_SUCCESS = 'FETCH_RESERVATION_SUCCESS';
export const FETCH_RESERVATION_ERROR = 'FETCH_RESERVATION_ERROR';

export const DELETE_OPERATION_LOADING = 'DELETE_OPERATION_LOADING';
export const DELETE_OPERATION_SUCCESS = 'DELETE_OPERATION_SUCCESS';
export const DELETE_OPERATION_ERROR = 'DELETE_OPERATION_ERROR';

export const FETCH_RESERVATION_FLOOR_LOADING = 'FETCH_RESERVATION_FLOOR_LOADING';
export const FETCH_RESERVATION_FLOOR_SUCCESS = 'FETCH_RESERVATION_FLOOR_SUCCESS';
export const FETCH_RESERVATION_FLOOR_ERROR = 'FETCH_RESERVATION_FLOOR_ERROR';

export const FETCH_OPERATION_SUCCESS = 'FETCH_OPERATION_SUCCESS';
export const FETCH_OPERATION_LOADING = 'FETCH_OPERATION_LOADING';
export const FETCH_OPERATION_ERROR = 'FETCH_OPERATION_ERROR';
export const DELETE_RESERVATION_SUCCESS = 'DELETE_RESERVATION_SUCCESS';
export const DELETE_RESERVATION_LOADING = 'DELETE_RESERVATION_LOADING';
export const DELETE_RESERVATION_ERROR = 'DELETE_RESERVATION_ERROR';

export const FETCH_DEPARTMENT_OPERATIONS_LOADING = 'FETCH_DEPARTMENT_OPERATIONS_LOADING';
export const FETCH_DEPARTMENT_OPERATIONS_SUCCESS = 'FETCH_DEPARTMENT_OPERATIONS_SUCCESS';
export const FETCH_DEPARTMENT_OPERATIONS_ERROR = 'FETCH_DEPARTMENT_OPERATIONS_ERROR';

export const FETCH_OPERATIONS_TODAY_LOADING = 'FETCH_OPERATIONS_TODAY_LOADING';
export const FETCH_OPERATIONS_TODAY_SUCCESS = 'FETCH_OPERATIONS_TODAY_SUCCESS';
export const FETCH_OPERATIONS_TODAY_ERROR = 'FETCH_OPERATIONS_TODAY_ERROR';

export const DELETE_MULTIPLE_RESERVATIONS_LOADING = 'DELETE_MULTIPLE_RESERVATIONS_LOADING';
export const DELETE_MULTIPLE_RESERVATIONS_SUCCESS = 'DELETE_MULTIPLE_RESERVATIONS_SUCCESS';
export const DELETE_MULTIPLE_RESERVATIONS_ERROR = 'DELETE_MULTIPLE_RESERVATIONS_ERROR';
